import React from 'react';
import { colors } from '../../../../../../packages/brand';
import { Box } from '../../../../../../packages/ui';
import { BodyText, UnderlineLink } from '../../../ui';

type OptInSubtextProps = {
  onLinkPress: () => void,
};

export const OptInSubtext: React.FC<OptInSubtextProps> = ({
  onLinkPress,
}) => (
  <Box paddingX={16}>
    <BodyText
      testID="ttp-checkout-optin-subtext"
      appearance="medium"
      textAlign="center"
      color={colors.metal}
    >
      <UnderlineLink
        onPress={onLinkPress}
        underlineVerticalOffset={2}
        underlineHeight={1}
        textAppearance="medium"
        tone="slate"
        testID="ttp-checkout-optin-subtext-link"
      >
        Set up Tap to Pay on iPhone
      </UnderlineLink>
      {' '}to check out clients with contactless payment
      methods. This can take up to a few minutes to complete.
    </BodyText>
  </Box>
);
